<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <slot name="title">
      <h3 class="m-v-0 m-b-10">各类文件上传</h3>
    </slot>
    <el-table :data="page" border ref="table">
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <span class="text-primary" v-if="scope.row.time_submit">已提交</span>
          <span class="text-warning" v-else>未提交</span>
        </template>
      </el-table-column>
      <el-table-column label="任务名称" prop="name" min-width="200">
        <template slot-scope="scope">
          <el-tooltip>
            <div class="oneline">
              <span v-html="$highlight(scope.row.name, scope.row.$$pinyin.name)"></span>
            </div>
            <div slot="content">
              <span v-html="$highlight(scope.row.name, scope.row.$$pinyin.name)"></span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="部门" prop="department_uid" width="150">
        <template slot-scope="scope">{{department_map[scope.row.department_uid]}}</template>
      </el-table-column>
      <el-table-column label="附件下载" prop="file.name">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.file" :content="scope.row.file.name">
            <div class="oneline">
              <a :href="scope.row.file.url"
                 :download="scope.row.file.name" target="_blank" class="link-success">
                <icon :name="scope.row.file.name | fileicon"></icon>
                {{scope.row.file.name}}
              </a>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发布日期" prop="time_create" width="160">
        <template slot-scope="scope">{{scope.row.time_create | sub(0, -3)}}</template>
      </el-table-column>
      <el-table-column label="我的提交" prop="teacher_file.name">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.teacher_file" :content="scope.row.teacher_file.name">
            <div class="oneline">
              <a :href="scope.row.teacher_file.url"
                 :download="scope.row.teacher_file.name" target="_blank" class="link-success">
                <icon :name="scope.row.teacher_file | fileicon"></icon>
                {{scope.row.teacher_file.name}}
              </a>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="no-padding" width="120">
        <template slot-scope="scope">
          <router-link :to="$location.collection_edit({collection_uid: scope.row.uid})"
                       class="el-button el-button--primary el-button--mini">查看
          </router-link>
          <select-file @change="selectFile(scope.row, $event)" :disabled="scope.row.$$loading">
            <el-button type="success" size="mini" :loading="scope.row.$$loading>0">
              {{scope.row.teacher_file ? '重新上传' : '上传文件'}}
            </el-button>
          </select-file>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length>pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'
import assign from 'lodash/assign'
import orderBy from 'lodash/orderBy'

import * as Collection from 'api/collection'
import * as Department from 'api/department'

import page from 'utils/page'

export default {
  data () {
    return {
      list: null,
      departments: null,
      department_map: null,
      ready: false,
      pageInfo: {page: 10, current: 1},
      search: '',
    }
  },
  computed: {
    filtered () {
      return this.$search(this.list, this.search, ['name'])
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [list, departments] = await Promise.all([
          Collection.teacher_list(),
          Department.list(),
        ])
        this.list = orderBy(list, [item => !item.time_submit, 'time_create'], ['desc', 'desc'])
        this.departments = departments
        this.department_map = mapValues(keyBy(departments, 'uid'), 'name')
        this.ready = true
      })
    },
    selectFile (collection, files) {
      this.$guard(collection, '$$loading')(async () => {
        let data = await Collection.teacher_edit({uid: collection.uid, teacher_file: files[0]})
        assign(collection, data)
        this.$message.success('上传成功')
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () {
      if (!this.$dontReload) this.init()
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/collection/CollectionList.vue